var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0016 26.5834C22.954 26.5834 23.7203 25.8171 23.7203 24.8647V15.698C23.7203 14.7491 22.9505 13.9792 22.066 13.9792C21.1816 13.9792 20.2828 14.7527 20.2828 15.698V24.8647C20.2828 25.8171 21.0562 26.5834 22.0016 26.5834ZM22.0016 28.9539C20.7583 28.9539 19.75 29.9622 19.75 31.2054C19.7529 32.4486 20.7555 33.4584 22.0016 33.4584C23.2477 33.4584 24.2531 32.4501 24.2531 31.2068C24.2503 29.9636 23.2477 28.9539 22.0016 28.9539Z",
    fill: "#EFB520"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M39.924 33.5299L24.6486 7.46216C23.4791 5.45695 20.5279 5.45695 19.3505 7.46216L4.08228 33.5299C2.90709 35.5279 4.37082 38.0416 6.7263 38.0416H37.2771C39.6232 38.0416 41.0913 35.5351 39.924 33.5299ZM20.2801 15.6978C20.2801 14.7489 21.0499 13.9791 21.9988 13.9791C22.9477 13.9791 23.7176 14.7525 23.7176 15.6978V24.8645C23.7176 25.8134 22.9477 26.5833 22.0633 26.5833C21.1788 26.5833 20.2801 25.817 20.2801 24.8645V15.6978ZM21.9988 33.4583C20.7556 33.4583 19.7473 32.4499 19.7473 31.2067C19.7473 29.9635 20.7549 28.9551 21.9988 28.9551C23.2428 28.9551 24.2504 29.9635 24.2504 31.2067C24.2475 32.4485 23.2449 33.4583 21.9988 33.4583Z",
    fill: "#EFB520"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.e9da8ea4.svg";
export { ForwardRef as ReactComponent };